var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState2Gray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.31079,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6757 41.2903C26.4478 44.1715 24.0964 47.305 20.4237 48.289C19.5056 48.5351 18.5918 48.6235 17.7255 48.5726",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.09 65.2278C32.8621 68.109 30.5107 71.2425 26.838 72.2265C25.9199 72.4726 25.0061 72.561 24.1398 72.5101",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5038 89.1653C39.2759 92.0465 36.9245 95.18 33.2519 96.164C32.3337 96.4101 31.4199 96.4985 30.5537 96.4476",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9024 17.8751L29.5586 31.3646C26.9688 32.0585 25.4319 34.7205 26.1259 37.3103L43.66 102.749C44.354 105.339 47.0159 106.875 49.6057 106.181L99.9495 92.6919C102.539 91.998 104.076 89.336 103.382 86.7462L85.8481 21.3078C85.1542 18.718 82.4922 17.1811 79.9024 17.8751Z",
    fill: "#EBEBEB",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0803 13.4766L19.7366 26.9662C17.1468 27.6601 15.6099 30.3221 16.3038 32.9119L33.838 98.3503C34.5319 100.94 37.1939 102.477 39.7837 101.783L90.1275 88.2935C92.7173 87.5995 94.2542 84.9375 93.5602 82.3477L76.0261 16.9094C75.3321 14.3196 72.6701 12.7827 70.0803 13.4766Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7258 48.5724C15.1269 48.42 12.9554 47.0146 12.3764 44.8537C11.6044 41.9724 13.9557 38.839 17.6284 37.8549C21.301 36.8708 24.9041 38.4088 25.6761 41.29",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1396 72.5099C21.5407 72.3575 19.3692 70.9521 18.7902 68.7912C18.0182 65.9099 20.3695 62.7765 24.0422 61.7924C27.7149 60.8083 31.3179 62.3463 32.0899 65.2275",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5535 96.4474C27.9546 96.295 25.783 94.8896 25.204 92.7287C24.432 89.8474 26.7833 86.714 30.456 85.7299C34.1287 84.7458 37.7317 86.2838 38.5038 89.165",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4443 46.7643C45.7735 45.6044 48.3426 41.1545 47.1826 36.8254C46.0226 32.4963 41.5728 29.9272 37.2436 31.0872C32.9145 32.2471 30.3454 36.697 31.5054 41.0261C32.6654 45.3552 37.1152 47.9243 41.4443 46.7643Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6523 43.4993C37.6523 43.4993 38.0543 42.0694 40.0435 41.5363C42.0328 41.0033 43.0959 42.0407 43.0959 42.0407",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6523 43.4993C37.6523 43.4993 38.0543 42.0694 40.0435 41.5363C42.0328 41.0033 43.0959 42.0407 43.0959 42.0407",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1531 39.2097C36.7805 39.0416 37.1528 38.3967 36.9847 37.7694C36.8166 37.142 36.1717 36.7697 35.5444 36.9378C34.917 37.1059 34.5447 37.7508 34.7128 38.3781C34.8809 39.0055 35.5258 39.3778 36.1531 39.2097Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2491 37.5769C42.8764 37.4088 43.2487 36.7639 43.0806 36.1366C42.9125 35.5092 42.2677 35.1369 41.6403 35.305C41.013 35.4731 40.6407 36.1179 40.8088 36.7453C40.9769 37.3727 41.6217 37.745 42.2491 37.5769Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.885 89.4597C57.2141 88.2997 59.7832 83.8499 58.6232 79.5207C57.4633 75.1916 53.0134 72.6225 48.6843 73.7825C44.3552 74.9425 41.7861 79.3923 42.946 83.7214C44.106 88.0505 48.5559 90.6196 52.885 89.4597Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7622 84.9609C48.7622 84.9609 49.8253 85.9984 51.8145 85.4653C53.8038 84.9323 54.2057 83.5023 54.2057 83.5023",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7622 84.9609C48.7622 84.9609 49.8253 85.9984 51.8145 85.4653C53.8038 84.9323 54.2057 83.5023 54.2057 83.5023",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5935 81.905C48.2209 81.7369 48.5932 81.092 48.4251 80.4647C48.257 79.8373 47.6122 79.465 46.9848 79.6331C46.3574 79.8012 45.9851 80.4461 46.1532 81.0734C46.3213 81.7008 46.9662 82.0731 47.5935 81.905Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.689 80.2722C54.3164 80.1041 54.6887 79.4592 54.5206 78.8319C54.3525 78.2045 53.7076 77.8322 53.0803 78.0003C52.4529 78.1684 52.0806 78.8133 52.2487 79.4406C52.4168 80.068 53.0617 80.4403 53.689 80.2722Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9995 67.4948C51.3286 66.3348 53.8977 61.885 52.7377 57.5559C51.5778 53.2267 47.1279 50.6576 42.7988 51.8176C38.4697 52.9776 35.9006 57.4274 37.0606 61.7566C38.2205 66.0857 42.6704 68.6548 46.9995 67.4948Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7083 59.9401C42.3356 59.772 42.708 59.1272 42.5399 58.4998C42.3718 57.8725 41.7269 57.5002 41.0996 57.6683C40.4722 57.8364 40.0999 58.4812 40.268 59.1086C40.4361 59.7359 41.0809 60.1082 41.7083 59.9401Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8042 58.3073C48.4316 58.1392 48.8039 57.4944 48.6358 56.867C48.4677 56.2397 47.8229 55.8674 47.1955 56.0355C46.5681 56.2036 46.1958 56.8484 46.3639 57.4758C46.532 58.1031 47.1769 58.4754 47.8042 58.3073Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1045 63.457L48.3535 62.0506",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1437 27.9342L51.5025 32.6611C51.0536 32.7814 50.7872 33.2428 50.9075 33.6917L51.5977 36.2675C51.7179 36.7164 52.1793 36.9828 52.6282 36.8625L70.2695 32.1355C70.7183 32.0152 70.9847 31.5538 70.8644 31.105L70.1743 28.5292C70.054 28.0803 69.5926 27.8139 69.1437 27.9342Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8871 49.3717L57.2459 54.0986C56.797 54.2189 56.5306 54.6803 56.6509 55.1292L57.3411 57.705C57.4613 58.1539 57.9227 58.4203 58.3716 58.3L76.0129 53.573C76.4617 53.4527 76.7281 52.9913 76.6079 52.5425L75.9177 49.9667C75.7974 49.5178 75.336 49.2514 74.8871 49.3717Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6315 70.8053L62.9903 75.5322C62.5414 75.6525 62.275 76.1139 62.3953 76.5628L63.0855 79.1386C63.2057 79.5875 63.6671 79.8538 64.116 79.7336L81.7573 75.0066C82.2061 74.8863 82.4725 74.4249 82.3522 73.9761L81.6621 71.4003C81.5418 70.9514 81.0804 70.685 80.6315 70.8053Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6134 107.106L113.534 98.1948C113.628 98.1701 113.716 98.1411 113.803 98.1122C113.81 98.1163 113.816 98.1149 113.82 98.1078C113.928 98.0912 114.034 98.0635 114.139 98.0358C117.694 97.1021 119.815 93.4697 118.881 89.9155C118.315 87.7608 116.754 86.1346 114.819 85.3903C113.571 84.9107 112.16 84.8063 110.761 85.174L76.477 89.3359C80.8174 88.9318 84.9297 91.7044 86.072 96.0528C87.3413 100.884 84.4505 105.835 79.6134 107.106Z",
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9104 67.6458L68.5616 100.65C69.8308 105.482 74.7815 108.373 79.613 107.103C84.4501 105.833 87.3409 100.882 86.0717 96.0505C84.9294 91.7021 80.817 88.9294 76.4766 89.3335L110.76 85.1717C112.16 84.804 113.57 84.9084 114.818 85.3879L106.932 55.2934C106.3 52.8888 103.839 51.4516 101.439 52.0818L63.115 62.1496C60.7103 62.7813 59.2787 65.2412 59.9104 67.6458Z",
    fill: "#F5F5F5",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5945 62.1523L93.352 71.0808",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5095 63.9961L100.438 69.2386",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9495 67.7852L71.707 76.7135",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8645 69.625L78.793 74.8675",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9119 77.6719L79.5405 82.4504",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96828 72.1641C9.96828 72.1641 5.6125 77.2742 10.6902 81.6323C5.61241 77.2741 1.22201 82.3543 1.22201 82.3543C1.22201 82.3543 5.57778 77.2443 0.5 72.886C5.57778 77.2443 9.96828 72.1641 9.96828 72.1641Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.806 26.7579C117.806 26.7579 113.45 31.8679 118.528 36.2261C113.45 31.8678 109.06 36.948 109.06 36.948C109.06 36.948 113.416 31.838 108.338 27.4797C113.416 31.838 117.806 26.7579 117.806 26.7579Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState2Gray);
export default __webpack_public_path__ + "static/media/empty_state_2gray.d72f3e114dcc8407876abd89a68ef352.svg";
export { ForwardRef as ReactComponent };